import { CLMButtonPrimary, CLMButtonPrimary1 } from "components/CLM/v3/Buttons";
import React, { useState } from "react";

function SignUpForm({ phone = true }) {
  const [fullName, setFullName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [email, setEmail] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form Data:", { fullName, phoneNumber, email });
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="bg-white px-8 py-10 w-full border border-gray-200 rounded-2xl"
    >
      <h2 className="text-3xl font-semibold text-gray-900 mb-8">
        Start Your Free Trial
      </h2>

      <div className="mb-6">
        <label
          htmlFor="fullName"
          className="block text-base font-medium text-gray-800 mb-2"
        >
          Full Name *
        </label>
        <input
          id="fullName"
          required
          type="text"
          placeholder="Enter your full name"
          value={fullName}
          onChange={(e) => setFullName(e.target.value)}
          className="block w-full border border-gray-300 px-4 py-3 text-base text-gray-900 focus:border-black focus:ring-1 focus:ring-black outline-none rounded-md font-medium"
        />
      </div>

      {phone && (
        <div className="mb-6">
          <label
            htmlFor="phoneNumber"
            className="block text-base font-medium text-gray-800 mb-2"
          >
            Phone Number *
          </label>
          <input
            id="phoneNumber"
            type="tel"
            required
            placeholder="+91 98765 43210"
            value={phoneNumber}
            onChange={(e) => setPhoneNumber(e.target.value)}
            className="block w-full border border-gray-300 px-4 py-3 text-base text-gray-900 focus:border-black focus:ring-1 focus:ring-black outline-none rounded-md font-medium"
          />
          <p className="text-sm text-gray-500 mt-2">
            You’ll receive an OTP on this number for verification.
          </p>
        </div>
      )}

      <div className="mb-8">
        <label
          htmlFor="email"
          className="block text-base font-medium text-gray-800 mb-2"
        >
          Email *
        </label>
        <input
          id="email"
          type="email"
          required
          placeholder="you@example.com"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="block w-full border border-gray-300 px-4 py-3 text-base text-gray-900 focus:border-black focus:ring-1 focus:ring-black outline-none rounded-md font-medium"
        />
      </div>
      <CLMButtonPrimary1
        buttonText={"Start Free Trial"}
        className="w-full"
        type="submit"
      />
    </form>
  );
}

export default SignUpForm;
